export const languages = {
  ENGLISH: 'en',
  FINNISH: 'fi',
};

export const languageLabels = {
  [languages.ENGLISH]: 'English',
  [languages.FINNISH]: 'Finnish',
};